const initialState = {
    showHowDoesItWorksPopup: false,
    showSupportDetailsPopup: false,
	tutorialPopup: false,
    videoPopup: null,
    showNotesPopup:false,
	userUnShareErrorPopup: null,
	confirmFreeLicensesPopup: null,
	isAdminPopup: false,
	directoryWriteErrorPopup: false,
	isProfileUpdatePropagationPopup: false,
	isUpgradeToBusinessPopup: false,
	isApproveDeletionPopupShown: false,
	isRejectDeletionPopupShown: false,
	isUserListAddCollaboratorsPopupShown: false,
	isAccessOrgUnitPopupShown: false,
	isDirectoryV5AccessPopupShown: false,
	recordingConfirmPopupDisplay: null,
	isContactWithAiPopupShown: null,
	isConfirmSwitchToFreePopupShown: false,
	isFreeEditionLabelContactLimitReachedPopupShown: false
};

const popupReducer = (state = initialState, action ) => {
    switch (action.type) {
        case "SHOW_HOW_DOES_IT_WORKS_POPUP":
            state = {
                ...state,
                showHowDoesItWorksPopup: action.payload
            };
            break;
        case "SHOW_SUPPORT_DETAILS_POPUP":
            state = {
                ...state,
                showSupportDetailsPopup: action.payload
            };
            break;
        case "SHOW_NOTES_POPUP":
            state = {
                ...state,
                showNotesPopup: action.payload
            };
            break;

	    case "TUTORIAL_POPUP":
		    state = {
			    ...state,
			    tutorialPopup: action.payload
		    };
		    break;
        case "VIDEO_POPUP":
            state = {
                ...state,
                videoPopup: action.payload
            };
            break;
		case "USER_UN_SHARE_ERROR_POPUP":
			state = {
				...state,
				userUnShareErrorPopup: action.payload
			};
			break;
	    case "CONFIRM_FREE_LICENSES_POPUP":
		    state = {
			    ...state,
			    confirmFreeLicensesPopup: action.payload
		    };
		    break;
	    case "IS_ADMIN_POPUP":
		    state = {
			    ...state,
			    isAdminPopup: action.payload
		    };
		    break;
	    case "DIRECTORY_WRITE_ERROR_POPUP":
		    state = {
			    ...state,
			    directoryWriteErrorPopup: action.payload
		    };
		    break;
	    case "IS_PROFILE_UPDATE_PROPAGATION_POPUP":
		    state = {
			    ...state,
			    isProfileUpdatePropagationPopup: action.payload
		    };
		    break;
	    case "IS_UPGRADE_TO_BUSINESS_POPUP":
		    state = {
			    ...state,
			    isUpgradeToBusinessPopup: action.payload
		    };
		    break;
		case "IS_APPROVE_DELETION_POPUP_SHOWN":
		    state = {
			    ...state,
			    isApproveDeletionPopupShown: action.payload
		    };
		    break;
		case "IS_REJECT_DELETION_POPUP_SHOWN":
			state = {
				...state,
				isRejectDeletionPopupShown: action.payload
			};
			break;
		case "IS_USER_LIST_ADD_COLLABORATORS_POPUP_SHOWN":
			state = {
				...state,
				isUserListAddCollaboratorsPopupShown: action.payload
			};
			break;
	    case "IS_ORG_UNIT_ACCESS_POPUP_SHOWN":
		    state = {
			    ...state,
			    isOrgUnitAccessPopupShown: action.payload
		    };
		    break;
	    case "IS_DIRECTORY_V5_ACCESS_POPUP_SHOWN":
		    state = {
			    ...state,
			    isDirectoryV5AccessPopupShown: action.payload
		    };
		    break;
		case "RECORDING_CONFIRM_POPUP_DISPLAY":
			state = {
				...state,
				recordingConfirmPopupDisplay: action.payload
			};
			break;
	    case "IS_CONTACT_WITH_AI_POPUP_SHOWN":
		    state = {
			    ...state,
			    isContactWithAiPopupShown: action.payload
		    };
		    break;
	    case "IS_CONFIRM_SWITCH_TO_FREE_POPUP_SHOWN":
		    state = {
			    ...state,
			    isConfirmSwitchToFreePopupShown: action.payload
		    };
		    break;
		case "IS_FREE_EDITION_LABEL_CONTACT_LIMIT_REACHED_POPUP_SHOWN":
			state = {
				...state,
				isFreeEditionLabelContactLimitReachedPopupShown: action.payload
			};
			break;
        default :
            break;
    }
    return state;
};

export default popupReducer;
